// ============================================================
// Datei: src/pages/ressorts/administration/AdministrationDesktop.jsx
// ============================================================

import React, { useState } from "react";

import VolunteerList from "../../../components/VolunteerList";
import ShiftTable from "../../../components/shiftTable/ShiftTable";
import EditVolunteerModal from "../../../components/EditVolunteerModal";

import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";

import "./administration.css";
import VolunteerPool from "../../../components/VolunteerPool";

const AdministrationDesktop = ({
	volunteers,
	setVolunteers,
	shifts,
	guests,
	selectedVolunteer,
	setSelectedVolunteer,
	activeTab,
	setActiveTab,
	reloadGuests,
	reloadVolunteers
}) => {
	// ============================================================
	// STATE
	// ============================================================
	const [guestToEdit, setGuestToEdit] = useState(null);
	const [guestToDelete, setGuestToDelete] = useState(null);

	const administration = shifts.filter(
		(s) => s.shiftId >= 1000 && s.shiftId <= 1001
	);

	const tabs = [
		{ id: "overview", label: "Übersicht" },
		{ id: "helpers", label: "Libellen" },
		{ id: "shifts", label: "Schichten" },
		{ id: "guests", label: "Gästeliste" },
		{ id: "extras", label: "Extrawürscht" }
	];

	return (
		<>
			<div className="tabs-container">
				<div className="tab-bar">
					{tabs.map((t) => (
						<button
							key={t.id}
							type="button"
							className={
								"tab-button" +
								(activeTab === t.id ? " tab-button-active" : "")
							}
							onClick={() => setActiveTab(t.id)}
						>
							{t.label}
						</button>
					))}
				</div>

				<div className="tab-panels">
					{activeTab === "helpers" && (
						<div className="helpers-layout">
							<div className="helpers-column helpers-column-left">
								<VolunteerList
									volunteers={volunteers}
									setVolunteers={setVolunteers}
									onEdit={(v) => setSelectedVolunteer(v)}
									reloadVolunteers={reloadVolunteers}
								/>
							</div>

							<div className="helpers-column helpers-column-right">
								<VolunteerPool
									departmentName="Administration"
									onAssigned={() => {
										if (reloadVolunteers) reloadVolunteers();
									}}
								/>
							</div>
						</div>
					)}

					{activeTab === "shifts" && (
						<>
							<h2 className="administration-subheading">
								Administration
							</h2>
							<ShiftTable
								shifts={administration}
								departmentName="Administration"
								autoRefresh={true}
							/>
						</>
					)}

					{activeTab === "guests" && (
						<>
							<GuestRegistration refreshGuestList={reloadGuests} />

							<GuestList
								guests={guests}
								refreshGuestList={reloadGuests}
								onEdit={(g) => setGuestToEdit(g)}
								onDelete={(g) => setGuestToDelete(g)}
							/>
						</>
					)}
				</div>
			</div>

			{selectedVolunteer && (
				<EditVolunteerModal
					volunteer={selectedVolunteer}
					onClose={() => setSelectedVolunteer(null)}
					onSaved={() => reloadVolunteers?.()}
				/>
			)}

			{guestToEdit && (
				<EditGuestModal
					guest={guestToEdit}
					onClose={() => setGuestToEdit(null)}
					onSaved={() => {
						setGuestToEdit(null);
						reloadGuests();
					}}
				/>
			)}

			{guestToDelete && (
				<DeleteGuestModal
					guest={guestToDelete}
					onClose={() => setGuestToDelete(null)}
					onDeleted={() => {
						setGuestToDelete(null);
						reloadGuests();
					}}
				/>
			)}
		</>
	);
};

export default AdministrationDesktop;